export const IconPhoneMobileNumber: {
  name: 'icon_phone_mobile_number-8bb8e8fe00e0'
} = {
  name: 'icon_phone_mobile_number-8bb8e8fe00e0'
}
